import {Injectable} from "@angular/core";
import {ReplaySubject} from "rxjs";

export interface CommunicationEvent {
  type: string;
  payload?: any;
}

@Injectable({
  providedIn: "root"
})
export class CommunicationHandlerService {
  private eventsSubject = new ReplaySubject<CommunicationEvent>(1);
  get events$() {
    return this.eventsSubject.asObservable();
  }

  constructor() {}

  protected handleResponse(response: CommunicationEvent): void {
    this.eventsSubject.next(response);
  }

  sendMessage(payload: any): void {
    this.eventsSubject.next({ type: 'message', payload });
  }

  clearSubject(): void {
    // Instead of sending null, complete the current subject and create a new one
    this.eventsSubject.complete();
    this.eventsSubject = new ReplaySubject<CommunicationEvent>(1);
  }

  emitEvent(event: CommunicationEvent): void {
    this.eventsSubject.next(event);
  }

  // functions to be overriden
  receiveMessages(message: string | undefined): void {}
}
